import { GenericBackendResponse } from '../genericBackendResponse';
import { PensionIsinCatalog } from './interfaces/PensionPlanTransfer';

const getPensionIsinCatalog = async (
	token: string
): Promise<GenericBackendResponse<PensionIsinCatalog[]>> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/catalog`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});

	return response.json();
};

export default getPensionIsinCatalog;
